import { extend } from 'sk-ui/lib/utils/util.js'

import copyOsTypeForm from './metaData/copyOsTypeForm'
import osTypeForm from './metaData/osTypeForm'

export default {
  osTypeCreate({ commit }, params) {
    const props = {}
    this.dispatch('OpenFullDialog', {
      metaData: osTypeForm,
      props
    })
  },
  osTypeEdit({ commit }, params) {
    const props = {
      title: '编辑操作系统',
      params: {
        id: params.rowIds[0]
      }
    }
    const editForm = extend(true, {}, osTypeForm)
    this.dispatch('OpenFullDialog', { metaData: editForm, props, clone: false })
  },
  osTypeCopyShow({ commit }, params) {
    const props = {}
    this.dispatch('OpenFullDialog', {
      metaData: copyOsTypeForm,
      props
    })
  },
  osTypeCopy({ commit }, params) {
    if (params?.response?.data?.status == 'SUCCESS') {
      this.dispatch('OpenNotification', { message: '复制成功', type: 'success' })
    }
  }
}
